// extracted by mini-css-extract-plugin
export default {"caption":"the-view-exclusive-offer_caption__Oygrq"};